import React, { CSSProperties } from 'react'

function QuotesSvg({
  className,
  style,
  color,
}: {
  className?: string
  style?: CSSProperties
  color: string
}) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 31 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.44 13V0.272H12.824V5.346C12.824 9.646 12.3367 13.1147 11.362 15.752C10.3873 18.3893 8.438 21.7433 5.514 25.814L0.526 23.406C3.278 19.1633 4.94067 15.6947 5.514 13H0.44ZM17.9524 13V0.272H30.3364V5.346C30.3364 9.646 29.8491 13.1147 28.8744 15.752C27.8998 18.3893 25.9504 21.7433 23.0264 25.814L18.0384 23.406C20.7904 19.1633 22.4531 15.6947 23.0264 13H17.9524Z"
        fill={color}
      />
    </svg>
  )
}

export default React.memo(QuotesSvg)
